export const MAX_INTEREST = 25;
export const MIN_INTEREST = 7;
export const DEFAULT_BALLOON_RANGE = { min: 0, max: 30 };
export const SLIDER_MODE1 = 1;
export const SLIDER_STEP_MODE_5000 = 5000;
export const INTEREST = 'interest';
export const MONTHLYPAYMENTTERM = ['12', '24', '36', '48', '60', '72', '90'];
export const BALLOONPAYMENT = ['%', 'R'] as const;
export const DEFAULT_PRICE_VEHICLE = 100000;
export const DEFAULT_INTEREST = 13.5;
export const DEFAULT_BALLOON = 0;
